"use strict";

function ajaxCallSpec(url, elem) {
  $.ajax({
    method: 'GET',
    url: url,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    success: function success(data) {
      showResultsSpec(elem);
      showSpecs(data.results, elem);
      replaceSpecialityValue(elem);
    },
    error: function error(err) {
      console.log(err);
    }
  });
}

function showResultsSpec(elem) {
  var results = elem.next(),
      input = elem.next();
  results.addClass('is-open');
  results.empty();
  $window.on('click', function () {
    results.removeClass('is-open');
  });
  results.click(function (event) {
    event.stopPropagation();
  });
}

function showSpecs(specialities, element) {
  var results = element.next();

  for (var i = 0; i < specialities.length; i++) {
    var title = specialities[i].name,
        id = specialities[i].id;
    var res = '<li class="js-spec-value" data-id="' + id + '">' + '<div>' + '<p>' + title + '</p>' + '</div>' + '</li>';
    results.append(res);
  }
}

function replaceSpecialityValue(element) {
  var menu = $(element).next(),
      items = menu.find('li');
  items.on('click', function () {
    var id = $(this).data('id');
    $(element).attr('data-id', id);
    $(element).attr('data-name', $(this).text());
    var value = $(this).text();
    $(element).val(value);
    menu.removeClass('is-open');
  });
}

function inputSpec(elem) {
  var timeout = null;

  elem.onkeyup = function (e) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      ajaxCallSpec('/api/v1/speciality?speciality=' + $(elem).val(), $(elem));
    }, 500);
  };
}